(() => {
  const dialog = document.getElementById('ts-product-zoom');
  const triggerTemplate = document.getElementById('ts-zoom-trigger');
  if (!dialog || !triggerTemplate || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const stage = dialog.querySelector('.ts-zoom-stage');
  const image = dialog.querySelector('.ts-zoom-image');
  const status = dialog.querySelector('.ts-zoom-status');
  const modeButtons = [...dialog.querySelectorAll('[data-zoom-mode]')];
  const pointers = new Map();
  let panel, opener, previousOverflow, sources, scale = 1, x = 0, y = 0;
  let gesture, moved = false, ready = false;
  const parse = (el) => { try { return JSON.parse(el?.textContent || 'null'); } catch { return null; } };
  const path = (src) => { try { return new URL(src, location.href).pathname; } catch { return ''; } };
  const distance = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
  function render() {
    const maxX = Math.max(0, (image.offsetWidth * scale - stage.clientWidth) / 2);
    const maxY = Math.max(0, (image.offsetHeight * scale - stage.clientHeight) / 2);
    x = Math.min(maxX, Math.max(-maxX, x));
    y = Math.min(maxY, Math.max(-maxY, y));
    image.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
    stage.classList.toggle('is-zoomed', scale > 1);
    dialog.querySelector('[data-zoom-out]').disabled = !ready || scale <= 1;
    dialog.querySelector('[data-zoom-in]').disabled = !ready || scale >= 4;
  }
  function setScale(value) {
    if (!ready) return;
    scale = Math.min(4, Math.max(1, value));
    if (scale === 1) x = y = 0;
    render();
  }
  function showMode(mode) {
    const thumb = panel.querySelector(`[data-ts-media-mode="${mode}"] img`);
    if (!thumb) return;
    const original = sources.find(item => path(item.src) === path(thumb.currentSrc || thumb.src));
    const src = original?.src || thumb.src;
    scale = 1; x = y = 0; ready = false; pointers.clear();
    image.style.transform = '';
    image.style.visibility = 'hidden';
    status.textContent = status.dataset.loading;
    modeButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.zoomMode === mode)));
    image.alt = mode === 'box' ? panel.querySelector('.ts-box-thumb-img')?.alt || panel.dataset.title : panel.querySelector('.ts-ps-img')?.alt || panel.dataset.title;
    image.width = original?.width || 1400;
    image.height = original?.height || 1400;
    image.onload = () => {
      ready = true; status.textContent = ''; image.style.visibility = ''; render();
    };
    image.onerror = () => { ready = false; status.textContent = status.dataset.error; render(); };
    image.src = src;
    render();
  }
  function open(media, trigger) {
    panel = media.closest('[data-ts-panel]');
    sources = parse(panel.querySelector('[data-ts-zoom-sources]')) || [];
    if (!sources.length || dialog.open) return;
    opener = trigger;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    modeButtons.forEach(button => {
      button.hidden = !panel.querySelector(`[data-ts-media-mode="${button.dataset.zoomMode}"]:not([hidden])`);
    });
    dialog.showModal();
    showMode(media.classList.contains('is-box') ? 'box' : 'product');
  }
  function init() {
    document.querySelectorAll('.ts-ps-media--socks').forEach(media => {
      if (media.querySelector('.ts-zoom-trigger')) return;
      const trigger = triggerTemplate.content.firstElementChild.cloneNode(true);
      media.append(trigger);
      media.addEventListener('click', event => {
        if (event.target.closest('button') && !event.target.closest('.ts-zoom-trigger')) return;
        if (Math.abs(event.clientX - (media._zoomStartX ?? event.clientX)) > 12 || Math.abs(event.clientY - (media._zoomStartY ?? event.clientY)) > 12) return;
        open(media, trigger);
      });
      media.addEventListener('pointerdown', event => {media._zoomStartX = event.clientX; media._zoomStartY = event.clientY;}, {passive:true});
    });
  }
  dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    pointers.clear(); gesture = null; ready = false; image.removeAttribute('src');
    opener?.focus({preventScroll:true});
  });
  dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
  dialog.querySelector('[data-zoom-in]').addEventListener('click', () => setScale(scale + .5));
  dialog.querySelector('[data-zoom-out]').addEventListener('click', () => setScale(scale - .5));
  dialog.querySelector('[data-zoom-reset]').addEventListener('click', () => setScale(1));
  modeButtons.forEach(button => button.addEventListener('click', () => showMode(button.dataset.zoomMode)));
  function startGesture() {
    const pts = [...pointers.values()];
    gesture = {points:pts, scale, x, y, distance:pts.length > 1 ? distance(pts[0], pts[1]) : 0};
  }
  stage.addEventListener('pointerdown', event => {
    if (!ready || (event.pointerType === 'mouse' && event.button !== 0)) return;
    stage.setPointerCapture(event.pointerId);
    pointers.set(event.pointerId, {x:event.clientX, y:event.clientY});
    if (pointers.size === 1) moved = false;
    else moved = true;
    startGesture();
  });
  stage.addEventListener('pointermove', event => {
    if (!pointers.has(event.pointerId) || !gesture) return;
    pointers.set(event.pointerId, {x:event.clientX, y:event.clientY});
    const pts = [...pointers.values()];
    if (pts.length > 1 && gesture.distance) {
      moved = true;
      setScale(gesture.scale * distance(pts[0], pts[1]) / gesture.distance);
    } else if (pts.length === 1) {
      const dx = pts[0].x - gesture.points[0].x, dy = pts[0].y - gesture.points[0].y;
      if (Math.hypot(dx,dy) > 6) moved = true;
      if (scale > 1) {x = gesture.x + dx; y = gesture.y + dy; render(); stage.classList.toggle('is-dragging', moved);}
    }
  });
  function endPointer(event) {
    if (!pointers.has(event.pointerId)) return;
    const tap = pointers.size === 1 && !moved && event.type === 'pointerup';
    pointers.delete(event.pointerId);
    if (pointers.size) startGesture();
    else {gesture = null; stage.classList.remove('is-dragging');}
    if (tap) setScale(scale > 1 ? 1 : 2.5);
  }
  stage.addEventListener('pointerup', endPointer);
  stage.addEventListener('pointercancel', endPointer);
  stage.addEventListener('lostpointercapture', endPointer);
  dialog.addEventListener('keydown', event => {
    if (event.key === '+' || event.key === '=') {event.preventDefault();setScale(scale + .5);}
    if (event.key === '-') {event.preventDefault();setScale(scale - .5);}
    if (event.key === '0') {event.preventDefault();setScale(1);}
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      const next = modeButtons.find(button => !button.hidden && button.getAttribute('aria-pressed') !== 'true');
      if (next) showMode(next.dataset.zoomMode);
    }
  });
  window.addEventListener('resize', () => {if (dialog.open) render();});
  document.addEventListener('shopify:section:load', init);
  init();
})();
